var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfSpecExists(_vm.spec))?_c('div',{class:_vm.classes},[(_vm.$slots.default)?_vm._t("default"):[_vm._v(_vm._s(_vm.spec))]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }